/* eslint-disable max-len */
const messages = {
  'datepicker.today': 'Hoje',
  'datepicker.yesterday': 'Ontem',
  'datepicker.this_week': 'Esta semana',
  'datepicker.last_week': 'Semana anterior',
  'datepicker.this_month': 'Este mês',
  'datepicker.last_month': 'Mês anterior',
  copy: 'Copiar',
  success: 'sucesso',
  error: 'Erro',
  'opening_time_status.close_confirmation_modal.reason.title': 'Motivo do fechamento',
  'opening_time_status.close_confirmation_modal.reason.required': 'Campo obrigatório',
  'driver.form.title.mobile-dealer': 'Para Revenda Móvel, selecione uma das lojas abaixo',
  'driver.form.title.partner-portal':
    'Para Portal do Parceiro, selecione abaixo as lojas de atuação',
  'general.cancel': 'Cancelar',
  'general.save': 'Salvar',
  'general.edit': 'Editar',
  'general.add': 'Adicionar',
  'general.save-changes': 'Salvar alterações',
  'general.show_more': 'Mostrar mais',
  'connection_snackbar.disconnect_message': 'Conexão perdida. Reconectando...',
  'general.is': 'está',
  'general.validation.required': 'Campo obrigatório',
  'general.validation.invalid-email': 'Insira um email válido',
  'general.validation.minimum-characters': 'Utilize no mínimo {num} caracteres',
  'general.validation.maximum-characters': 'Utilize no máximo {num} caracteres',
  'general.validation.full-name': 'Pelo menos o nome e sobrenome são requeridos',
  'general.validation.driver-license-number': 'Utilize exatamente 11 números',
  'general.validation.driver-username': 'Formato Inválido',
  'general.validation.invalid-date': 'Data inválida',
  'general.validation.passwords-do-not-match': 'As senhas não são iguais',
  'general.validation.only-numbers': 'Somente números são permitidos',
  'general.validation.alphanumeric': 'Somente números ou letras são permitidos',
  'general.validation.cnpj': 'O CNPJ não está completo',
  'general.label.email': 'Endereço de e-mail',
  'general.label.password': 'Sua senha',
  'general.errors.generic': 'Ocorreu um erro, por favor tente novamente.',
  'general.send': 'Enviar',
  'general.no-data': 'Não há dados disponíveis',
  app_title: 'Chama Portal do Parceiro',
  app_description: 'Gerenciamento de pedidos de botijões de gás',
  'login.header.prefix': 'Bem-vindo ao',
  'login.header.title': 'Portal do Parceiro',
  'login.validation.invalid-password': 'Usuário ou senha inválida, tente novamente.',
  'login.validation.temporary-blocked':
    'Usuário e senha bloqueados. Por favor espere 5 minutos e tente novamente.',
  'login.link.forgot-password': 'Esqueci minha senha',
  login_title: 'Bem vindo(a) ao Portal do Parceiro!',
  login_field_username: 'Seu login',
  login_field_dealer: 'Sua loja',
  login_button_signing_in: 'Entrando...',
  login_button_sign_in: 'Entrar',
  login_error_incorrect: 'Ops! Alguma dessas informações está incorreta.',
  login_error_closed_modal: 'Ops você fechou o pop-up',
  login_error_unauthorised: 'Você não tem permissão',
  logout_textlink: 'Sair',
  tickets_overview_loading: 'Carregando pedidos',
  tickets_overview_title: 'Visão geral do pedido',
  tickets_overview_processing_title: 'Em processamento',
  tickets_overview_type_new_client: 'Novo cliente',
  orderdetails_title: 'Seu novo pedido',
  orderdetails_none_selected: 'Por favor, selecione um pedido.',
  orderdetails_step_call_customer: 'Ver telefone',
  orderdetails_step_script_a:
    'Obrigado por usar o Chama! Infelizmente o revendedor [dealer name] não está disponível, mas podemos enviar um botijão de gás da marca Supergasbras com um desconto de R$ 10',
  orderdetails_step_script_b:
    'Obrigado por usar o Chama! Gostaríamos de verificar seu pedido, endereço e método de pagamento. Este endereço está correto?',
  orderdetails_step_confirm_address: 'Este é o seu endereço?',
  orderdetails_step_hangup: 'Agradeça ao cliente e desligue o telefone.',
  orderdetails_step_call_driver: 'Ligue para o entregador.',
  orderdetails_step_finalisation: 'Finalização',
  orderdetails_step_finalisation_finish: 'Aceitar pedido',
  orderdetails_step_finalisation_decline: 'Recusar pedido',
  orderdetails_step_finalisation_decline_cancel: 'Cancelar',
  orderdetails_step_finalisation_decline_confirm: 'Sim, recusar',
  tickets_overview_type_finalised: 'Entregue',
  tickets_overview_type_declined: 'Recusado',
  tickets_overview_finalised_show_more: 'Clique para mostrar mais.',
  tickets_overview_incoming: 'Novos pedidos',
  tickets_overview_beingdelivered: 'Pedidos em andamento',
  tickets_overview_finalised: 'Pedidos concluídos',
  tickets_overview_incoming_empty_message: 'Você não tem novos pedidos.',
  tickets_overview_beingdelivered_empty_message: 'Você não tem pedidos em andamento.',
  tickets_overview_finalised_empty_message: 'Você não tem pedidos concluídos.',
  logout_confirm_title: 'Por favor, confirme.',
  logout_confirm_sure: 'Tem certeza que deseja sair?',
  logout_confirm_cancel: 'Ficar',
  logout_confirm_logout: 'Sair',
  logout_confirm_description:
    'Sua loja continuará aberta ou fechada de acordo com os horários de funcionamento definidos na página de Produtos e Cobertura',
  alert_sound: 'Som de alerta',
  menu_welcome: 'Bem vindo(a),',
  menu_mandatory: 'Obrigatório',
  ticket_someone: 'Entregador',
  ticket_eta: 'Horário previsto de entrega:',
  delivery_maps: 'Veja o mapa',
  delivery_timeline: 'Acompanhe seu pedido',
  delivery_timeoforder: 'Horário do Pedido',
  delivery_deliverystarted: 'Entrega iniciada',
  delivery_etasetto: 'Entrega prevista para',
  delivery_bottledelivered: 'Botijão entregue',
  delivery_shouldbedelivered: 'Botijão deveria ser entregue em',
  deliveryDetailsView_CancelOrder: 'Cancelar pedido',
  deliveryDetailsView_CancelOrderCancel: 'Não',
  deliveryDetailsView_CancelOrderConfirm: 'Sim',
  deliveryDetailsView_OrderDelivered: 'Pedido entregue',
  deliveryDetailsView_DiscardChanges: 'Ignorar alterações',
  deliveryDetailsView_SaveChanges: 'Salvar alterações',
  delivery_toolate: 'Pedido em atraso',
  dealerCancelled: 'Recusado',
  dealerDelivered: 'Entregue',
  userCancelled: 'Recusado pelo cliente',
  additionalInfo: 'Informações adicionais para entrega:',
  payingWith: 'Você irá pagar com...',
  creditCard: 'Crédito',
  client: 'Cliente',
  debitCard: 'Débito',
  cash: 'Dinheiro',
  totalAmount: 'O total será de...',
  closeLabel: 'Fechar',
  ticketdetails_step_drivercoming:
    'O entregador está a caminho! Logo você poderá ver o tempo estimado de chegada.',
  nameUnknown: 'Nome desconhecido',
  labelSelect: 'Selecione...',
  labelPaymentMethod: 'Tipo de pagamento:',
  open: 'aberta',
  'open.plural': 'abertas',
  closed: 'fechada',
  'closed.plural': 'fechadas',
  disabled: 'desabilitada',
  'disabled.plural': 'desabilitadas',
  dealers_not_visible:
    '{count, number} não {count, plural, one {visível} other {visíveis}} no aplicativo',
  dealers_not_visible_details:
    '({count, number} {count, plural, one {desabilitado} other{desabilitados}})',
  in_the_app: 'no aplicativo',
  it_will_close_automatically: 'Ela fechará automaticamente',
  it_will_open_automatically: 'Ela abrirá automaticamente',
  time_at: 'às',
  time_to: 'às',
  opened_opening_times_status_tooltip:
    'Isso quer dizer que sua loja está visível para os clientes fazerem pedidos. Você precisa estar disponível para processá-los e entregá-los!',
  'opened_opening_times_status_tooltip.multi_shop':
    'Isso quer dizer que estas lojas estarão visíveis para os clientes fazerem pedidos. Você precisa estar disponível em cada loja para processá-los e entregá-los!',
  closed_opening_times_status_tooltip:
    'Isso quer dizer que sua loja não está visível para os clientes no aplicativo, então você não receberá pedidos.',
  'closed_opening_times_status_tooltip.multi_shop':
    'Isso quer dizer que estas lojas não estarão visíveis para os clientes no aplicativo, então você não receberá pedidos para cada loja fechada.',
  'payment_type.unknown': 'desconhecido',
  'orderdetails.decline_description': 'Tem certeza de que quer recusar o pedido?',
  'orderdetails.cancel_description': 'Tem certeza de que quer cancelar o pedido?',
  'menu.shop_info': 'Cadastro da loja',
  'menu.edit_shop_info': 'Alterar informações',
  'menu.terms_and_conditions': 'Termos & Condições',
  'menu.stores': 'Minhas lojas',
  'menu.dealer_blocked': 'Revendedor bloqueado',
  'menu.drivers': 'Entregadores',
  'menu.balance': 'Finanças',
  'menu.order-history': 'Histórico de pedidos',
  'menu.training-materials': 'Treinamento',
  customers_view_in_the_app: 'Como os clientes vão te ver no aplicativo',
  info_for_all_users: 'Essas informações aparecem para todos os usuários.',
  your_sign_up_info_on_chama: 'Seu cadastro no Chama',
  chama_team_access_only:
    'Somente a equipe do Chama tem acesso a esses dados. Entre em contato para corrigir ou atualizá-los',
  company_name: 'Razão Social',
  location: 'Localização',
  manager_phone: 'Telefone da gerência',
  cylinder_p13_price: 'Preço do gás P-13',
  contact_phone_number: 'Telefone de atendimento',
  name_on_the_app: 'Seu nome no aplicativo (Nome fantasia)',
  keep_info_updated: 'Mantenha essas informações sempre atualizadas!',
  edit: 'Editar',
  'admin.shopinfo.cancel': 'Cancelar',
  'admin.shopinfo.save': 'Salvar',
  info_has_been_updated: 'As informações foram atualizadas',
  generic_error_message: 'Desculpe, nós tivemos um erro inesperado.',
  'generic_error_message.help_text': 'Por favor, entre em contato com o Chama.',
  everything_is_fine: 'Tudo certo',
  saving: 'Salvando',
  loading: 'Carregando',
  no_info: 'Sem informações',
  back_to_orders: 'Voltar para pedidos',
  back_to_financial_balance: 'Voltar para o Balanço Financeiro',
  insert_name_here: 'Insira o nome aqui',
  are_you_sure: 'Tem certeza que deseja sair?',
  unsaved_changes_will_be_lost: 'Informações não salvas serão perdidas.',
  dealer_list: 'Revendedores',
  orders: 'Pedidos',
  admin: 'Administração',
  yes_im_sure: 'Sim, tenho certeza',
  welcome_to_chama_dealer_tool: 'seja bem vindo(a) ao Chama Revendedor!',
  please_accept_terms_below:
    'Por favor, aceite os Termos Gerais de Credenciamento abaixo para utilizar o sistema.',
  i_accept_terms_and_conditions:
    'Eu aceito os Termos e Condições acima para utilizar o Chama Revendedor.',
  you_have_already_signed: 'Você já aceitou o documento de Termos e Condições',
  accept: 'Aceitar',
  continue: 'Continuar',
  processing: 'Em processamento...',
  cancelled_by_customer: 'Cancelado pelo cliente',
  cancelled_at: 'Cancelado às',
  cancelled_by_customer_call_driver: 'Cancelado pelo cliente, ligue para o entregador',
  succesfully_handled: 'Entregue com sucesso',
  cancelled_by_dealer: 'Cancelado pelo revendedor',
  declined_by_dealer: 'Recusado pelo revendedor',
  cancelled_by_cs: 'Cancelado pela equipe do Chama',
  declined_by_cs: 'Recusado pela equipe do Chama',
  in_delivery: 'Em entrega',
  delivered_confirmed_at: 'Entrega confimada às',
  cancelled_time: 'Horário do cancelamento',
  order_cancelled: 'Pedido cancelado',
  order_cancelled_at: 'Pedido cancelado as',
  the_order_has_been_cancelled_by_customer:
    'O cliente acabou de cancelar este pedido. Vamos movê-lo para pedidos finalizados.',
  dismiss: 'Dispensar',
  close_window: 'Fechar janela',
  attention: 'Atenção',
  ok_i_understand: 'Ok, entendi.',
  the_driver_was_informed: 'Já avisei ao entregador',
  address: 'Endereço',
  the_order_has_been_cancelled_by_customer_warn_driver:
    'O cliente acabou de cancelar este pedido. Ligue para o entregador não ir ao endereço à toa!',
  ill_warn_soon: 'Vou avisar em breve',
  postpone: 'Adiar',
  you_terms_are_unsigned:
    'Você ainda não assinou os Termos e Condições, clique aqui para visualizar',
  you_have_orders_you_can_check_them:
    'Você tem pedidos pendentes. Se quiser, você pode ler os termos e condições depois.',
  postpone_sign_go_to_orders_now: 'Adiar assinatura e ir para pedidos agora',
  continue_reading_terms: 'Continuar lendo os termos',
  you_have_orders: 'Você tem pedidos',
  store_info_has_been_updated: 'Loja editada com sucesso',
  'edit_shop_info.description':
    'Precisa atualizar o preço ou horário de funcionamento? Basta editar abaixo!',
  gas_price: 'Preço do gás',
  customer_only_visible_information: 'Dados visíveis para o cliente',
  internal_chama_information: 'Dados internos para o Chama',
  opening_times: 'Horário de entrega',
  monday: 'Segunda-feira',
  tuesday: 'Terça-feira',
  wednesday: 'Quarta-feira',
  thursday: 'Quinta-feira',
  friday: 'Sexta-feira',
  saturday: 'Sábado',
  sunday: 'Domingo',
  holiday: 'Feriado',
  'admin.editOpeningTimes.closed': 'Fechado',
  you_changes_opening_times_a_week_ago:
    'Você mudou seu horário de funcionamento há 1 semana. Gostaria de revisá-lo? Clique aqui!',
  'opening_times.validation.default': 'Por favor informe um horário válido',
  'opening_times.validation.comparison':
    'O horário de fechamento não pode ser menor do que o de abertura',
  'opening_times.validation.closedWeek': 'Pelo menos um dia da semana deve estar aberto',
  'opening_times.remind_me_text': 'Lembrar-me em uma semana de mudar o horário novamente',
  'opening_times.message':
    'Preencha com os horários em que você de fato tem funcionários aptos a usar o Revendedor Chama e entregar os pedidos.',
  opens_at: 'Abre às',
  closes_at: 'Fecha às',
  to: 'às',
  opens: 'abre',
  closes: 'fecha',
  day: 'dia',
  days: 'dias',
  minute: 'minuto',
  'minutes.short': 'min',
  minutes: 'minutos',
  hour: 'hora',
  hours: 'horas',
  today: 'hoje',
  tomorrow: 'amanhã',
  week: 'Semana',
  expired: 'expirado',
  check_opened_days: 'marque os dias abertos',
  hey_it_seems_that: 'Ei, parece que',
  is_already_taking_care_of_this_order: 'já está cuidando deste pedido.',
  name: 'nome',
  phone_number: 'Telefone',
  not_available: 'Não informado',
  change_for: 'Troco para',
  'order_details.copy_order_details': 'Copiar detalhes do pedido',
  'order_details.copy_dealer_phone': 'Copiar telefone',
  'order_details.order_id': 'ID do Pedido',
  'order_details.order_id.title': 'ID',
  'order_details.order_id.copy.notification.success': 'ID do Pedido copiado com sucesso',
  'order_details.order_id.copy.notification.failure': 'Não foi possível copiar o ID do pedido',
  'order_details.customer.name': 'Nome do cliente',
  'order_details.customer.name.not_available': 'Nome do cliente não disponível',
  'order_details.customer.phone': 'Telefone',
  'order_details.customer.address': 'Endereço',
  'order_details.customer.address_extra': 'Complemento',
  'order_details.customer.remark': 'Observações',
  'order_details.customer.order': 'Pedido',
  'order_details.customer.order_on': 'Pedido em',
  'order_details.table.quantity': 'Qtde.',
  'order_details.table.brand': 'Marca',
  'order_details.table.product': 'Produto',
  'order_details.table.unit_price': 'Preço unit.',
  'order_details.table.payment': 'Pagamento',
  'order_details.table.order_total': 'Total do pedido',
  'order_details.payment_method.cash': 'Dinheiro',
  'order_details.payment_method.debit': 'Débito',
  'order_details.payment_method.credit': 'Crédito',
  'order_details.payment_method.inAppPayment': 'Pagamento no aplicativo',
  'order_details.sales_channel.chama': 'Chama',
  'order_details.sales_channel.shop': 'Telefone',
  'order_details.payment_method.cash.short': 'Din',
  'order_details.payment_method.debit.short': 'Déb',
  'order_details.payment_method.credit.short': 'Cred',
  'order_details.payment_method.inAppPayment.short': 'App',
  'order_details.payment_method.pincode.valid': 'Código confirmado: {code}',
  'order_details.payment_method.pincode.not_valid': 'Código não confirmado',
  'order_details.payment_method.bring_card_machine': 'Este pagamento é na porta, levar maquininha',
  'opening_times.feedback_message.success_closing': 'LOJA FECHADA COM SUCESSO',
  'opening_times.feedback_message.success_closing.plural': 'LOJAS FECHADAS COM SUCESSO',
  'opening_times.feedback_message.success_reopening': 'LOJA REABERTA COM SUCESSO',
  'opening_times.feedback_message.success_reopening.plural': 'LOJAS REABERTAS COM SUCESSO',
  'opening_time_status.close_confirmation_modal.body_text':
    'Enquanto a loja estiver fechada, você não receberá pedidos do Chama. Não se esqueça de processar os pedidos que já estão em andamento!',
  'opening_time_status.close_confirmation_modal.body_text2':
    'Você pode reabri-la a qualquer momento ainda hoje, ou esperar até o próximo dia de abertura, quando ela abrirá normalmente de acordo com seu horário de funcionamento padrão.',
  'opening_time_status.close_confirmation_modal.multi_shop.body_text':
    'Enquanto suas lojas estiverem fechadas, você não receberá pedidos do Chama em nenhuma delas. Não se esqueça de processar os pedidos que já estão em andamento!',
  'opening_time_status.close_confirmation_modal.multi_shop.body_text2':
    'Você pode reabri-las a qualquer momento ainda hoje, ou esperar até o próximo dia de abertura de cada uma, quando elas abrirão normalmente de acordo com seus respectivos horários de funcionamento padrão.',
  'opening_time_status.open_confirmation_modal.multi_shop.title':
    'Tem certeza de que deseja abrir suas lojas agora?',
  'opening_time_status.close_confirmation_modal.title': 'Qual é o motivo do fechamento hoje?',
  'opening_time_status.open_confirmation_modal.title':
    'Tem certeza de que deseja abrir a loja agora?',
  'opening_time_status.open_confirmation_modal.multi_shop.body_text':
    'Ao abrir suas lojas, elas estarão disponíveis para receber pedidos do aplicativo Chama, e você precisa estar preparado para atendê-los.',
  'opening_time_status.open_confirmation_modal.body_text':
    'Ao abrir a loja, ela estará disponível para receber pedidos do aplicativo Chama, e você precisa estar preparado para atendê-los.',
  close_now: 'fechar agora',
  close_stores: 'fechar lojas',
  keep_open: 'manter aberto',
  keep_closed: 'manter fechado',
  reopen_now: 'reabrir agora',
  reopen_stores: 'reabrir lojas',
  open_shop_now: 'reabrir loja agora',
  open_shops_now: 'reabrir lojas agora',
  you_have_closed_your_shop_manually: 'Você fechou a loja manualmente',
  reopen_by_clicking_the_button_or_wait_until: 'Reabra clicando ao lado ou espere até',
  'incoming_orders.dialog_message':
    'Por favor, aceite ou recuse os pedidos que ainda estão em aberto. Os clientes te avaliam de acordo com o atendimento e a agilidade de entrega.',
  'being_delivered_orders.dialog_message':
    'Não se esqueça de confirmar as entregas assim que elas acontecerem! Os clientes te avaliam de acordo com o atendimento e a agilidade de entrega.',
  'order_page.opening_modal.title': 'Vamos ao trabalho! Abrindo em {seconds} segundos…',
  'order_page.opening_modal.body_text':
    'Sua loja vai abrir automaticamente e você ficará disponível para receber pedidos no aplicativo.',
  'order_page.closing_modal.title': 'Hora de encerrar! Fechando em {seconds} segundos…',
  'order_page.closing_modal.body_text':
    'Sua loja vai fechar automaticamente e você ficará indisponível para receber novos pedidos. Você ainda poderá processar os pedidos em andamento.',
  'web_notifications.title': 'Chama revendedor',
  'web_notifications.new_order.body': 'Chegou um novo pedido para você! Clique aqui e veja!',
  'web_notifications.being_delivered_order.body':
    'Acabou o prazo de entrega de um dos pedidos. Você já entregou? Clique aqui para conferir e atualizar o pedido!',
  'web_notifications.consumer_cancelled.body':
    'Um pedido foi cancelado pelo cliente. Clique aqui e veja.',
  'web_notifications.dealer_declined.body':
    'Um revendedor acabou de recusar um pedido. Clique aqui e veja.',
  'web_notifications.dealer_cancelled.body':
    'Um revendedor acabou de cancelar uma entrega. Clique aqui e veja.',
  between: 'entre',
  and: 'e',
  your_shops: 'Suas lojas',
  store_name_in_the_app: 'Nome fantasia da loja no aplicativo',
  your_shop_is: 'sua loja está',
  shop_is: 'loja está',
  'shop_is.plural': 'lojas estão',
  multishop: 'Multi lojas',
  dealer_disabled: 'Desabilitado',
  dealer_enabled: 'Habilitado',
  dealer_blocked: 'Bloqueado',
  dealer_suspended: 'Suspenso',
  dealer_tc_expired: 'TC Expirado',
  shop_disabled_explanation_1: 'Esta loja está desabilitada. Entre em contato com o',
  shop_disabled_explanation_2: 'para mais detalhes.',
  'shop_status.open_online': 'Aberta & Online',
  'shop_status.open_offline': 'Aberta & Offline',
  'shop_status.closed_online': 'Fechada & Online',
  'shop_status.closed_offline': 'Fechada & Offline',
  'shop_status.adhoc_closed_online': 'Fechada (temporariamente) & Online',
  'shop_status.adhoc_closed_offline': 'Fechada (temporariamente) & Offline',
  dealers_selected: 'Revendedores selecionados',
  filters: 'Filtros',
  reallocate: 'realocar',
  dealers_nearby_order_address: 'Revendedores próximos ao endereço do pedido',
  'name.uppercase': 'NOME',
  'brand.uppercase': 'MARCA',
  'phone.uppercase': 'TELEFONE',
  'price.uppercase': 'PREÇO',
  'eta.uppercase': 'TEMPO DE ENTREGA',
  'office_hours.uppercase': 'EXPEDIENTE',
  order_dealer: 'Revendedor deste pedido',
  dealers_nearby: 'Revendedores próximos',
  there_is_no_other_dealers_nearby: 'Não existem outros revendedores próximos',
  cheapest: 'Mais barato',
  fastest: 'Mais rápido',
  best_rated: 'Melhor avaliação',
  'nearby.filters.delivery_time': 'ETA',
  price: 'Preço',
  brand: 'Marca',
  type: 'Tipo',
  product: 'Produto',
  take_over_order: 'Controlar este pedido',
  proceed: 'Prosseguir',
  you_are_about_to_control_this_order: 'Você está prestes a controlar este pedido',
  take_control_modal_body_text1:
    'Ao controlar este pedido, somente a Chama poderá tomar ações sobre o mesmo até que libere o controle novamente.',
  take_control_modal_body_text2:
    'Todas as ações feitas neste pedido refletirão na Dealer Tool do revendedor, no aplicativo e no sistema da Chama.',
  chama_team: 'a Equipe do Chama',
  new_version_changes: 'Mudanças da nova versão',
  order_details_voucher_message:
    'Código promocional utilizado. A Chama pagará de volta o valor do desconto.',
  discount: 'Desconto',
  cancellation_reason: 'Razão do cancelamento',
  default_cancellation_reason: 'Desconhecida',
  cancellation_reason_code_other: 'Outro',
  cancellation_reason_code_testing: 'Teste',
  cancellation_reason_code_dealerTooSlow: 'Revendedor devagar',
  cancellation_reason_code_noInAppPayment: 'Sem pagamento no app',
  cancellation_reason_code_enteredWrongData: 'Dados errados',
  'cancellation_reason_code_other.dt': 'Outro',
  'cancellation_reason_code_testing.dt': 'Testando o app',
  'cancellation_reason_code_dealerTooSlow.dt': 'O revendedor demorou',
  'cancellation_reason_code_noInAppPayment.dt': 'O app não oferece meio de pagamento',
  'cancellation_reason_code_enteredWrongData.dt': 'O cliente inseriu dados errados',
  cancellation_reason_code_vehicleProblem: 'Veículo com problema',
  cancellation_reason_code_shopAboutToClose: 'Loja próxima ao fechamento',
  cancellation_reason_code_incorrectInfo: 'Informação do pedido incorreta',
  cancellation_reason_code_fakeOrder: 'Pedido falso ou trote',
  cancellation_reason_code_consumerRequest: 'Solicitado pelo cliente',
  cancellation_reason_code_invalidPhone: 'Telefone inválido',
  cancellation_reason_code_invalidAddress: 'Endereço inválido',
  'menu.order_history': 'Histórico de pedidos',
  'status.dealer_accepted': 'Em entrega',
  'status.declined_by_dealer': 'Recusado (loja)',
  'status.cancelled_by_dealer': 'Cancelado (loja)',
  'status.cancelled_by_consumer': 'Cancelado (cliente)',
  'status.dealer_delivered': 'Entregue',
  'iap.pin.match': 'Código de entrega deve ter 4 números',
  'general.missing_information': 'Não informado',
  'general.order_late': 'Atrasado',
  'general.free_bottle': 'Botijão grátis',
  'general.free_bottle.plural': 'Botijões grátis',
  'action_buttons.new_order.decline_reason_text':
    'Para recusar este pedido por favor informe um motivo abaixo:',
  'action_buttons.new_order.decline_other_reason_text_field_hint': 'Insira aqui a razão',
  'action_buttons.missing_reason_error': 'Por favor escolha uma razão',
  'action_buttons.missing_other_reason_text_error': 'Por favor digite a outra razão no campo acima',
  'dealer_cancel_modal.decline_reason_text':
    'Para cancelar este pedido por favor informe um motivo abaixo:',
  'dealer_cancel_modal.decline_other_reason_text_field_hint': 'Insira aqui a razão',
  'dealer_cancel_modal.missing_reason_error': 'Por favor escolha uma razão',
  'dealer_cancel_modal.missing_other_reason_text_error': 'Por favor digite a razão no campo acima',
  'dealer_cancel_modal.dealer_cancel.about_to_close': 'Minha loja já vai fechar',
  'dealer_cancel_modal.veichle_problem': 'Estou com problemas no veículo',
  'dealer_cancel_modal.invalid_consumer_address': 'Endereço do cliente inválido',
  'dealer_cancel_modal.invalid_consumer_phone': 'Telefone do cliente inválido',
  'dealer_cancel_modal.dealer_declined.consumer_requested': 'Cliente solicitou o cancelamento',
  'dealer_cancel_modal.dealer_declined.fake_order': 'O pedido foi um trote',
  'disabled_warning.status': 'SUA LOJA ESTÁ DESATIVADA',
  'disabled_warning.status_explanation':
    'Você não poderá receber pedidos enquanto estiver desativado.',
  'disabled_warning.status_explanation2': 'Por favor entre em contato com o Chama no e-mail',
  'expired_terms.status_explanation':
    'Você não poderá receber pedidos enquanto não aceitar os Termos & Condições abaixo.',
  'disabled_warning.status.multishop': 'LOJA DESATIVADA',
  'disabled_warning.status.multishop.plural': 'LOJAS DESATIVADAS',
  'terms_countdown.message':
    'Você ainda não aceitou os Termos & Condições. Não se esqueça de aceitar até a o dia {deadline} ou então sua loja não estará apta a utilizar o Chama.',
  choose_your_shop: 'Escolha a loja',
  balance: 'Saldo',
  date: 'data',
  coupon: 'cupom',
  'order_history.customer_address': 'ENDEREÇO',
  'order_history.order_id': 'ID DO PEDIDO',
  'order_history.received_from_consumer': 'RECEBIDO<br />DO CLIENTE',
  'order_history.order_total': 'TOTAL<br />DO PEDIDO',
  'order_history.chama_comission': 'COMISSÃO<br />DO CHAMA',
  'order_history.dealer_net_result': 'RESULTADO LÍQ<br />DO REVENDEDOR',
  'order_history.net_result': 'Resultado Liquido',
  'order_history.show_more': 'MOSTRAR MAIS',
  'order_history.show_more_periods': 'MOSTRAR PERÍODOS ANTERIORES',
  'order_history.periods_end': 'Não há mais períodos para mostrar',
  'order_history.no_periods_msg': 'Não há dados a serem exibidos',
  'order_history.see_details': 'Ver detalhes',
  'order_history.orders_totals': 'Total de pedidos',
  close_temporarely: 'fechar temporariamente',
  this_store_is: 'Esta loja está',
  'error_message.missing_eta': 'Por favor escolha o horário previsto de entrega',
  'general.dealer': 'revendedor',
  'general.enable': 'habilitar',
  'general.disable': 'desabilitar',
  'mdt.enable_dealer_modal_text':
    'Ao habilitar um revendedor ele voltará a aparecer no aplicativo e poderá receber pedidos novamente.<br />Você tem certeza que deseja <strong>habilitar</strong> o revendedor <strong>{shop}</strong>?',
  'mdt.disable_dealer_modal_text':
    'Ao desabilitar um revendedor ele não irá mais aparecer no aplicativo e não poderá receber pedidos.<br />Você tem certeza que deseja <strong>desabilitar</strong> o revendedor <strong>{shop}</strong>?',
  'order_snippet.copy_id': 'Copiar ID do pedido',
  'order_snippet.telephone_order': 'Pedido por telefone',
  delivery_confirmed_by_consumer: 'Entrega confirmada pelo cliente',
  order_details_consumer_delivered_status: 'Este pedido foi confirmado pelo cliente como entregue',
  'orders.cs_processed_message': 'Este pedido foi aceito pela equipe do Chama',
  close_warning: 'Fechar aviso',
  see_history: 'Ver história',
  order_event_history: 'História de eventos do pedido',
  'order_event_history.ordered': 'Novo pedido',
  'order_event_history.ordered.cs': 'Novo pedido',
  'order_event_history.dealerProcessing': 'Processado pelo revendedor',
  'order_event_history.dealerProcessing.cs': 'Processado pela equipe do Chama',
  'order_event_history.dealerAccepted': 'Aceito pelo revendedor',
  'order_event_history.dealerAccepted.cs': 'Aceito pela equipe do Chama',
  'order_event_history.dealerCancelled': 'Cancelado pelo revendedor',
  'order_event_history.dealerCancelled.cs': 'Cancelado pela equipe do Chama',
  'order_event_history.dealerDeclined': 'Recusado pelo revendedor',
  'order_event_history.dealerDeclined.cs': 'Recusado pela equipe do Chama',
  'order_event_history.dealerDelivered': 'Entregue pelo revendedor',
  'order_event_history.dealerDelivered.cs': 'Entregue pela equipe do Chama',
  'order_event_history.consumerCancelled': 'Cancelado pelo consumidor',
  'order_event_history.consumerCancelled.cs': 'Cancelado pelo consumidor',
  'order_info.reveal-phone-number': 'Ver número',
  'opening_times_status.holiday_message': 'Hoje é feriado',
  'mdt.opening_times_status.holiday_message': 'Modo feriado',
  'password_recovery.label.password': 'Nova senha',
  'password_recovery.label.password_repeat': 'Repita a nova senha',
  'password_recovery.heading': 'Redefinir senha',
  'password_recovery.button': 'Enviar',
  'password_recovery.errors.link_expired.message': 'Seu link expirou',
  'password_recovery.errors.link_expired.help_text': 'Clique para solicitar um novo link',
  'password_recovery.errors.link_expired.button': 'Solicitar novo link',
  'password_recovery.success.message': 'Nova senha foi definida',
  'password_recovery.success.help_text': 'Por favor, faça login no novo Portal do Parceiro',
  'password_recovery.success.button': 'ok',
  'forgot_password.heading': 'Esqueceu sua senha?',
  'forgot_password.sub_title':
    'Insira seu endereço de e-mail e nós enviaremos um link para que você crie uma nova',
  'forgot_password.success.heading': 'Tudo certo!',
  'forgot_password.success.subtitle':
    'Em alguns minutos um e-mail será enviado para {email} com um link para sua redefinição de senha.',
  'forgot_password.success.ok': 'ok',
  'auth/weak-password': 'Por favor insira uma senha com pelo menos 6 dígitos',
  'auth/expired-action-code': 'Tempo para resetar senha esgotado, por favor tente novamente.',
  'auth/user-not-found': 'Usuário não encontrado ou incorreto.',
  'auth/wrong-password': 'Senha incorreta',
  'auth/chama-legacy-login':
    'Você está tentando utilizar credenciais não mais suportadas. Por favor entrar em contato através do seu grupo do whatsapp com a equipe do chama ou utilize o chat no canto inferior-direito da tela.',
  fetch_more_is_over_message: 'Não há mais pedidos para serem exibidos',
  deprecated_login_message:
    'Você precisa utilizar o endereço do "revendedor chama" fornecido pela equipe do Chama. Por favor entre em contato através do chat (localizado no canto inferior-direito) ou através do email revendedores@chamatheapp.com',
  not_supported_browser_warning:
    'O navegador recomendado para usar o Chama é o {browser}. Acesse a página por ele ou <a href="{downloadLink}">faça o download aqui se não tiver ele instalado.</a>',
  manage_products: 'Gerenciar produtos',
  no_products_available: 'Sem produtos',
  remove: 'Remover',
  remove_product_title: 'Remover produto',
  remove_product_body: 'Você tem certeza que deseja remover este produto?',
  add_product_title: 'Adicionar novo produto',
  add_product: 'Adicionar produto',
  remove_product_confirmation: 'Você tem certeza que deseja remover este produto?',
  choose_a_brand: 'Escolha uma marca',
  'order_history.legal_document.invoice': 'Recibo',
  'order_history.legal_document.payment_slip': 'Boleto',
  'order_history.file_error.generic_message': 'Um erro ocorreu ao tentar fazer download do arquivo',
  'order_history.file_error.not_found': 'Arquivo ainda não disponível para download',
  'order_details.driver_dropdown_label': 'Selecionar entregador',
  select_driver: 'Escolha um entregador',
  'order_details.driver': 'Entregador:',
  'delivery_status.pending': 'Entregador ainda não iniciou a entrega',
  'delivery_status.accepted': 'Aceito pelo entregador',
  'delivery_status.ongoing': 'Entregador iniciou a entrega',
  'delivery_status.rejected': 'Rejeitado pelo entregador',
  'delivery_status.delivered': 'Entregador finalizou a entrega',
  'delivery_status.cancelled': 'A entrega foi cancelada devido ao cancelamento do pedido',
  'delivery_tag.accepted': 'Pedido aceito',
  'delivery_tag.pending': 'Preparar entrega',
  'delivery_tag.ongoing': 'Em entrega',
  'delivery_tag.delivered': 'Entregue',
  'delivery_tag.rejected': 'Recusado',
  'delivery_tag.cancelled': 'Cancelado',
  'order_sound.disabled':
    'Seu navegador não reproduzirá som até você clicar em qualquer área da página',
  'orders.new': 'Pedidos - Beta',
  'order_queue.incoming':
    '{count, plural, =0 {Novos pedidos} one {Novo pedido} other {Novos pedidos}}',
  'order_queue.beingDelivered': 'Em andamento',
  'order_queue.finalized': 'Concluídos',
  'dealer.notification.blocked.multishop':
    '({count, number}) {count, plural, one {loja está bloqueada} other {lojas estão bloqueadas}}, no momento você não tem acesso ao sistema. Por favor entre em contato com o Chama.',
  'dealer.notification.suspended.multishop':
    '({count, number}) {count, plural, one {loja está suspensa e NÃO está visível } other {lojas estão suspensas e NÃO estão visíveis }} para os clientes. Por favor entre em contato com o Chama.',
  'dealer.notification.blocked.single':
    'Sua loja está bloqueada, no momento você não tem acesso ao sistema. Por favor entre em contato com o Chama.',
  'dealer.notification.suspended.single':
    'Sua loja está suspensa e NÃO está visível para os clientes. Por favor entre em contato com o Chama.',
  'dealer.notification_blocked_title':
    'Infelizmente {count, plural, one {sua loja está bloqueada} other {suas lojas estão bloqueadas}}',
  'dealer.notification.contract':
    '{shopNames} - Documentos em análise. Assim que aprovado, você poderá iniciar suas vendas pelo Chama',
  'dealer_blocked.info':
    '{count, plural, one {A loja} other {As lojas}} <b>{dealerName}</b> {count, plural, one {está bloqueada} other {estão bloqueadas}}',
  'order_status-badge.delivered': 'Entregue',
  'order_status-badge.dealerDelivered': 'Entregue',
  'order_status-badge.consumerDelivered': 'Consumidor confirmou a entrega',
  'order_status-badge.dealerCancelled': 'Cancelado pela revenda',
  'order_status-badge.chamaDeclined': 'Recusado pelo Chama',
  'order_status-badge.chamaCancelled': 'Cancelado pelo Chama',
  'order_status-badge.chamaOwned': 'Controlado pelo Chama',
  'order_status-badge.dealerDeclined': 'Recusado pela revenda',
  'order_status-badge.consumerCancelled': 'Cancelado pelo consumidor',
  'order_status-badge.customerCancelled': 'Cancelado pelo consumidor',
  'order_status-badge.chargebackdealerpays': 'Estorno',
  'order_status-badge.commission': 'Compensado',
  'order_status-badge.refund': 'Reembolso',
  'order_channel-badge.shop': 'Telefone',
  'order_detail-eta.deliveryTime': 'Tempo de entrega',
  'order_detail-eta.delivery': 'Entrega',
  'order_detail-eta.creationTime': 'Entrada',
  'order_detail-eta.cancelled': 'Cancelado',
  'order_detail-eta.delivered': 'Entregue',
  'order_detail-eta.dealerCancelled': 'Cancelado pela revenda',
  'order_detail-eta.dealerDeclined': 'Recusado pela revenda',
  'order_detail-eta.customerCancelled': 'Cancelado pelo consumidor',
  'order_detail-eta.required': 'Por favor selecione o tempo de entrega',
  'order_detail-eta.suggested-time': 'Sugerido no app',
  'order_detail-eta.dateAtTime': '{orderDate} às {orderTime}',
  'order_detail-driver.title': 'Entregador',
  'order_detail-driver.assign': 'Selecione um entregador',
  'order_detail-driver.re-assign': 'Trocar entregador',
  'order_detail-driver.selector.placeholder': 'Selecione um entregador',
  'order_detail-driver.selector.empty': 'Sem entregadores disponíveis',
  'order_detail-driver.selector.duration-minutes': '{ minutes } min até entrega',
  'order_detail-driver.selector.duration-hours': '{ hours } h { minutes } min até entrega',
  'order_detail-driver.selector.deliveries':
    '{deliveries, number} {deliveries, plural, one {entrega} =0 {entregas} other {entregas}}',
  'order_detail-driver.assign-action.cancel': 'Cancelar',
  'order_detail-driver.assign-action.assign': 'Confirmar o entregador',

  'order_detail-driver.no-drivers-enabled-title': 'Você ainda não possui entregadores ativos',
  'order_detail-driver.no-drivers-enabled': 'Adicionar entregador',
  order_copy: 'Copiar pedido',
  order_copied: 'Pedido copiado',
  'order-details.buttons.edit': 'Editar pedido',
  'driver_selector.driver_not_found': 'Sem entregadores disponíveis',
  'driver_selector.select': 'Selecionar',
  'driver_selector.loading_driver': 'Carregando',
  'driver_selector.delivery': 'Entregador',
  no_driver_text: 'Nenhum',
  'order_detail-product-info.quantity': 'Qtde',
  'order_detail-product-info.unitPrice': 'Preço un',
  'order_detail-product-info.totalPrice': 'Preço total',
  'transaction_detail-product-info.voucherLabel': 'Cupom',
  'order_detail-product-info.voucherLabel': 'Cupom de desconto',
  'order_detail-product-info.creditLabel': 'Créditos Chama',
  'order_detail-product-info.voucherDescription': 'Pago pelo Chama',
  'order_detail-product-info.voucherExplanation':
    'Será pago pelo Chama no próximo ciclo de pagamento selecionado',
  'order_detail-product-info.changeLabel': 'Troco:',
  financial_balance: 'Saldo',
  'financial_balance.balance': 'Saldo',
  'financial_balance.balance_help': 'Como funciona o saldo?',
  'financial_balance.overview': 'Documentos',
  'financial_balance.orders': 'Pedidos',
  'financial_balance.orders.download_csv': 'Download do Relatório',
  'financial_balance.orders.csv_not_available': 'Relatório indisponível para download',
  'financial_balance.orders.csv_period_not_settled':
    'Relatório estará disponível para download no final do período',
  'financial_balance.productivity': 'Produtividade',
  'financial_balance.productivity_title': 'Desconto por produtividade',
  'financial_balance.productivity_discount': 'Desconto por produtividade',
  'ui.datepicker.ok': 'Ok',
  'ui.datepicker.cancel': 'Cancelar',
  'financial_balance.your_balance': 'Seu Saldo',
  'financial_balance.your_overview': 'Seus Documentos',
  'financial_balance.your_orders': 'Seus Pedidos',
  'financial_balance.settings': 'Saldo',
  'financial_balance.transactions': 'Transações',
  'financial_balance.documents': 'Documentos',
  'financial_balance.documents.transaction_fees': 'Taxas de transação',
  'financial_balance.documents.commission': 'Comissão',
  'financial_balance.current_balance': 'Saldo atual',
  'financial_balance.month_balance': 'Saldo',
  'financial_balance.message_payment': 'Seu próximo pagamento será em',
  'financial_balance.message_payment_zero_old': 'Seu saldo atual é zero',
  'financial_balance.message_payment_zero': 'Seu saldo atual é zero',
  'financial_balance.message_payment_positive_old':
    'Esse valor será pago ao longo do mês em duas datas: a primeira em até 5 dias úteis a partir do dia {paymentDate} desse mês e a segunda no quinto dia útil do próximo mês.',
  'financial_balance.message_payment_positive':
    'Seu saldo atual é positivo. Ele será pago em {paymentDate}.',
  'financial_balance.message_payment_negative_old':
    'Caso seu saldo seja negativo, você receberá um boleto em 5 dias úteis após {paymentDate}',
  'financial_balance.message_payment_negative':
    'Seu saldo atual é negativo. No final do período, nós cobraremos se o saldo a pagar for superior a R$ 500,00. Caso contrário, seu saldo será transferido para o próximo período.',
  'financial_balance.withdraw_earlier': 'Receber antes',
  'financial_balance.start_of_period': 'Início do período',
  'financial_balance.end_of_period': 'Fim do período',
  'financial_balance.end_of_period_help': 'O que é um período?',
  'financial_balance.view_details': 'Ver pedidos',
  'financial_balance.filter.search': 'Pesquisar',
  'financial_balance.filter.from': 'De',
  'financial_balance.filter.to': 'até',
  'financial_balance.filter.select_period': 'Selecione o período',
  'financial_balance.unavailable': 'Não disponível',
  'financial_balance.overview.commission': 'Comissão',
  'financial_balance.overview.transaction-costs': 'Taxa de Transação',
  'financial_balance.transactions.date': 'Data',
  'financial_balance.transactions.name': 'Cliente',
  'financial_balance.transactions.payment': 'Pagamento',
  'financial_balance.transactions.status': 'Status',
  'financial_balance.transactions.order_value': 'Total do Pedido',
  'financial_balance.transactions.affect_balance': 'Saldo',
  'financial_balance.download_boleto': 'Baixar boleto',
  'financial_balance.transactions.total_orders': 'Total em pedidos',
  'financial_balance.transactions.money_in': 'Receitas',
  'financial_balance.transactions.vouchers': 'Cupons promocionais',
  'financial_balance.transactions.in_app_payment': 'Pago no aplicativo',
  'financial_balance.transactions.tax': 'Taxas',
  'financial_balance.transactions.money_out': 'Despesas',
  'financial_balance.transactions.transaction_fees': 'Taxas de transação',
  'financial_balance.transactions.credit_card_fees': 'Taxa do cartão de crédito',
  'financial_balance.transactions.total_earnings': 'Arrecadação total',
  'financial_balance.transactions.download_invoice': 'Baixar fatura',
  'financial_balance.transactions.coupon': 'Cupom',
  'financial_balance.period-selector.before-iap-period': 'Meses anteriores',
  'financial_balance.transactionsBeforeIAP':
    'Atualizamos nosso sistema financeiro em {date}. Para visualizar seus pedidos e documentos anteriores, {link}.',
  'financial_balance.transactionsBeforeIAPLinkContent': 'clique aqui',
  'financial_balance.transactionsBeforeIAPLinkPreviousOrders': 'Pedidos previas',
  'financial_balance.transactionsUnavailable': 'Você não recebeu pedidos neste período.',
  'financial_balance.commission': 'Comissão',
  'financial_balance.documents.open': 'Abrir',
  'financial_balance.settlements.to_customer.chargebackdealerpays': 'Valor para Estorno',
  'financial_balance.settlements.to_customer.commission': 'Valor para Compensado',
  'financial_balance.settlements.to_customer.refund': 'Valor para Reembolso',
  'financial_balance.settlements.fee.chargebackdealerpays': 'Taxa de Estorno',
  'financial_balance.settlements.fee.commission': 'Taxa de Compensado',
  'financial_balance.settlements.fee.refund': 'Taxa de Reembolso',
  'financial_balance.settlements.payments.no_payments': 'Sem pendências',
  'financial_balance.settlements.payments.made': 'Pagamento efetuado',
  'financial_balance.settlements.payments.scheduled': 'Pagamento agendado',
  'financial_balance.settlements.payments.rollover': 'Cobrança adiada',
  'financial_balance.settlements.payments.paid': 'Boleto pago',
  'financial_balance.settlements.payments.issued': 'Boleto emitido',
  'financial_balance.settlements.bill_due': 'Boleto válido até',
  'financial_balance.settlements.history.ant_tier_scheduled':
    'Ciclo de Antecipação {tier}: Pagamento agendado para {date}',
  'financial_balance.settlements.history.ant_tier_sent':
    'Ciclo de Antecipação {tier}: enviado para você em {date}',
  'financial_balance.settlements.history.bol_to_pay':
    'Você possui boleto a ser pago até {date}. Caso já tenha sido pago, em breve seu histórico estará atualizado.',
  'financial_balance.settlements.amount': 'Valor Apurado',
  'financial_balance.settlements.total_transactions': 'Total de Pedidos',
  'financial_balance.settlements.balance_components': 'Detalhes do Saldo Final',
  'financial_balance.settlements.starting_balance': 'Saldo Inicial',
  'financial_balance.settlements.iap': 'Pagamento no App',
  'financial_balance.settlements.card_fee': 'Taxa de Transação',
  'financial_balance.settlements.ant_fee': 'Taxa de Antecipação',
  'financial_balance.settlements.ant_fee_tier': 'Ciclo de Antecipação',
  'financial_balance.settlements.without_anticipation': 'Sem antecipação',
  'financial_balance.settlements.with_anticipation': 'Com antecipação',
  'financial_balance.settlements.vouchers': 'Cupons',
  'financial_balance.settlements.refunds': 'Reembolso',
  'financial_balance.settlements.refund_amount': 'Valor para Reembolso',
  'financial_balance.settlements.refund_fee': 'Taxa de Reembolso',
  'financial_balance.settlements.refund_message':
    'Um reembolso de {total} foi gerado ao consumidor devido a: {memo}',
  'financial_balance.settlements.chargebacks': 'Estorno',
  'financial_balance.settlements.chargeback_amount': 'Valor para Estorno',
  'financial_balance.settlements.chargeback_fee': 'Taxa de Estorno',
  'financial_balance.settlements.chargebackdealerpays_message':
    'Um estorno de {total} foi gerado ao consumidor devido a: {memo}',
  'financial_balance.settlements.delivered-unconfirmed_memo':
    'Cliente não reconheceu a compra efetuada e o código de entrega não foi informado',
  'financial_balance.settlements.irrf_commission': 'IRRF sobre Comissão',
  'financial_balance.settlements.irrf_fee': 'IRRF sobre taxa de Transação e Anticipação',
  'financial_balance.settlements.commission_compensation': 'Ajustes e Compensações',
  'financial_balance.settlements.commission_compensation_amount': 'Valor Compensado',
  'financial_balance.settlements.commission_fee': 'Comissão do Chama',
  'financial_balance.settlements.commission_message':
    'Uma compensação de comissão foi gerado ao consumidor devido a: {memo}',
  'financial_balance.settlements.total': 'Saldo Total',
  'financial_balance.settlements.status_payout': 'Saldo a receber',
  'financial_balance.settlements.status_charge': 'Saldo a pagar',
  'financial_balance.settlements.status_rollover': 'Valor a ser cobrado no próximo período',
  'financial_balance.settlements.history': 'Extrato',
  'financial_balance.settlements.history.period': 'Período',
  'financial_balance.settlements.history.settlement_date': 'Data da transação',
  'financial_balance.settlements.history.status': 'Status',
  'financial_balance.settlements.history.amount': 'Total',
  'financial_balance.settlements.modal.user_selected': 'Você escolheu o Ciclo de Antecipação',
  'financial_balance.settlements.modal.user_selected_zero':
    'Você escolheu não antecipar o pagamento',
  'financial_balance.settlements.modal.user_selected_anticipation':
    'Você escolheu antecipar o pagamento',
  'financial_balance.settlements.modal.period': 'Período',
  'financial_balance.settlements.modal.anticipation_selection': 'Opções de antecipação',
  'financial_balance.settlements.modal.anticipation_selection_help':
    'Como funciona a antecipação do pagamento?',
  'financial_balance.settlements.modal.no_acticipation': 'Sem antecipação',
  'financial_balance.settlements.modal.with_anticipation': 'Com antecipação',
  'financial_balance.settlements.modal.anticipation_tier': 'Ciclo de Antecipação',
  'financial_balance.settlements.modal.paid_on': 'Pago em',
  'financial_balance.settlements.modal.rate': 'Taxa',
  'financial_balance.settlements.modal.no_fee': 'Sem taxa',
  'financial_balance.settlements.modal.notice':
    'Taxa aplicada nos pedidos pagos via app no período selecionado.',
  'financial_balance.settlements.modal.deadline':
    'Você ainda pode alterar o seu Ciclo de antecipação até',
  'financial_balance.settlements.modal.confirm': 'Confirmar',
  'financial_balance.settlements.modal.total': 'Saldo Final',
  'financial_balance.settlements.rollover_to_period': 'O saldo passa para o próximo período',
  'financial_balance.settlements.rollover_to_period.link': 'Ver pedidos do período',
  'financial_balance.driver-productivity.no-deliveries-message': 'Nenhuma entrega no dia',
  'financial_balance.driver-productivity.no-data-message':
    'Sem informação de produtividade para o dia',
  'financial_balance.driver-productivity.date': 'D [de] MMMM YYYY',
  'financial_balance.driver-productivity.loading-message': 'Carregando produtividade do dia',
  'financial_balance.driver-productivity.header-driver': 'Entregador',
  'financial_balance.driver-productivity.header-orders': 'Total de pedidos entregues',
  'financial_balance.driver-productivity.header-discount': 'Desconto de produtividade',
  'financial_balance.driver-productivity.footer-message': 'A loja economizou:',
  'financial_balance.driver-productivity.footer-no-deliveries-message':
    'Sem desconto por produtividade',
  'financial_balance.driver-productivity.discount-explanation':
    'Economize na comissão Chama com a produtividade diária de cada entregador',
  'financial_balance.driver-productivity.discount-tier-to': 'até a {to}ª entrega',
  'financial_balance.driver-productivity.discount-tier-between': 'da {from}ª a {to}ª entrega',
  'financial_balance.driver-productivity.discount-tier-from': 'após a {from}ª entrega',
  'financial_balance.driver-productivity.error-message':
    'Ops! Não foi possível carregar as informações de produtividade deste dia.',
  'financial_balance.driver-productivity.refresh-tooltip': 'Atualizar',
  'financial_balance.driver-productivity.try-again': 'Tentar novamente',
  download_pdf: 'Baixar PDF',
  nota_fiscal: 'Nota fiscal',
  back: 'Voltar',
  'order_detail-cancellation.cancelOrder': 'Cancelar pedido',
  'order_detail-cancellation.whatIsTheReason': 'Qual o motivo?',
  'order_detail-refusal.decline': 'Recusar pedido',
  'order_detail-refusal.accept': 'Aceitar pedido',
  'order_detail-refusal.finalize': 'Finalizar pedido',
  'order_detail-refusal.acknowledgeNewOrderCancelation': 'Ok, entendi',
  'order_detail-refusal.acknowledgeDeliveryCancelation': 'Avisei o Entregador',
  'order_detail-giveUp.other': 'Outros',
  'order_status-message.beingDelivered': 'Pedido a caminho',
  'order_status-message.chamaAssigned': 'Chama está controlando este pedido',
  'order_status-message.otherUserControlling': 'Outro usuário está controlando esse pedido',
  'order_status-message.customerCancelled': 'Cliente cancelou o pedido',
  'order_status-message.delivered': 'Pedido entregue',
  'order_status-message.dealerDelivered': 'Entregue',
  'order_status-message.dealerDeclined': 'Recusado (Loja)',
  'order_status-message.dealerCancelled': 'Cancelado (Loja)',
  'order_status-message.consumerCancelled': 'Cancelado (Cliente)',
  'order_status-message.chamaDeclined': 'Recusado (Chama)',
  'order_status-message.chamaCancelled': 'Cancelado (Chama)',
  'order_status-message.chargebackdealerpays': 'Estorno',
  'order_status-message.commission': 'Compensado',
  'order_status-message.refund': 'Reembolso',
  show_reason: 'Ver motivo',
  'dashboard.ordersReceived': 'Recebidos',
  'dashboard.ordersLost': 'Cancelados',
  'dashboard.totalDeliveredOrders': 'Entregues',
  'dashboard.ordersDeliveredWithDelay': 'Atrasados',
  'orders_queue.empty': 'Nenhum pedido no momento.',
  onboarding: 'Onboarding',
  'onboarding.start': 'começar',
  'onboarding.welcome.hello': 'Olá {name},',
  'onboarding.welcome.message': 'bem-vindo ao Chama Revendedor, vamos começar.',
  'onboarding.general.panel-title': 'Informações Gerais',
  'onboarding.general.section.account': 'Informações operacionais',
  'onboarding.general.section.area': 'Área de atendimento',
  'onboarding.general.section.area.text':
    'Para definir sua área de entrega, iremos utilizar o serviço Google MyMaps. É só definir a sua região e em seguida colar o link no campo abaixo. Para entender melhor veja as dicas no botão abaixo.',
  'onboarding.general.section.area.hints.button': 'Dicas do mapa',
  'onboarding.general.section.consumer-app': 'Informações mostradas para o cliente',
  'onboarding.general.label.supportPhone': 'Telefone para contato com o Chama',
  'onboarding.general.label.serviceAreaMapLink': 'Link para Google My Maps',
  'onboarding.general.label.publicName': 'Nome fantasia da loja no aplicativo',
  'onboarding.general.label.publicPhone': 'Telefone de atendimento',
  'onboarding.general.google-maps-tooltip-1':
    'Criar um novo mapa em "Google My Maps" ({ link }). Coloque um marcador no local exato da revenda',
  'onboarding.general.google-maps-tooltip-2': 'Desenhe uma ou mais áreas de entrega',
  'onboarding.general.google-maps-tooltip-3':
    'A área de entrega não pode ter dentro dela uma área descoberta ou fazer intersecções nela mesma',
  'onboarding.general.google-maps-tooltip-4':
    'Compartilhar o mapa com a permissão "Qualquer um com o link pode visualizar"',
  'onboarding.general.google-maps-tooltip-5': 'Cole o link no campo acima',
  'onboarding.general.google-maps-tooltip-6':
    'Espere no mínimo 2 minutos para enviar o formulário (tempo de processamento do mapa).',
  'onboarding.general.form.errors.zero-locations': 'O mapa deve incluir a localização da revenda',
  'onboarding.general.form.errors.multiple-locations':
    'O mapa não pode conter mais de uma localização de revenda',
  'onboarding.general.form.errors.zero-polygons': 'O mapa deve conter 1 ou mais áreas de entrega',
  'onboarding.general.form.errors.polygons-errors':
    'A área de entrega não pode área descoberta ou fazer intersecções nela mesma',
  'onboarding.general.form.errors.invalid-url':
    'Endereço do mapa inválido. Ele está compartilhado corretamente?',
  'onboarding.general.form.errors.fetch-unauthorized':
    'A permissão deve estar configurada como "Qualquer pessoa com o link"',
  'onboarding.general.form.errors.fetch-error': 'Erro de mapa desconhecido',
  'onboarding.password.panel-title': 'Informações da sua conta',
  'onboarding.password.section': 'Sua conta é',
  'onboarding.password.label.password': 'Agora, nós vamos definir sua senha',
  'onboarding.password.label.password-repeat': 'Por favor, coloque sua senha novamente',
  'onboarding.password.helptext.password': 'A senha deve ter ao menos 8 dígitos',
  'onboarding.completed.heading': 'Pronto!',
  'onboarding.completed.subTitle': 'Agora é hora de explorar o Chama!',
  'onboarding.finalized.popup.title': 'Você já está cadastrado',
  'onboarding.finalized.popup.text':
    'Você já concluiu este passo. Basta ir ao Portal do Parceiro e fazer o login.',
  'onboarding.finalized.popup.button-text': 'Ok, entendi',
  'onboarding.error.link_expired.heading': 'Ops... o link expirou.',
  'onboarding.validation.invalid-phone-number': 'Número de telefone inválido',
  'onboarding.validation.invalid-google-area': 'Área do Google inválida',
  'onboarding.error.oops': 'Ops',
  'onboarding.error.retry': 'tente novamente',
  'onboarding.mymaps.tutorial.title': 'Passos para criar área de atendimento',
  'onboarding.mymaps.tutorial.1':
    'Criar um novo mapa em "Google My Maps" (https://www.google.com/mymaps). Coloque um marcador no local exato da revenda.',
  'onboarding.mymaps.tutorial.2': 'Desenhe uma ou mais áreas de entrega.',
  'onboarding.mymaps.tutorial.3':
    'A área de entrega não pode ter dentro dela uma área descoberta ou fazer intersecções nela mesma.',
  'onboarding.mymaps.tutorial.4': 'Duas áreas de entrega podem se sobrepor.',
  'onboarding.mymaps.tutorial.5':
    'Compartilhar o mapa com a permissão "Qualquer um com o link pode visualizar".',
  'onboarding.mymaps.tutorial.6':
    'Cole o link no campo abaixo e aguarde o processamento. Quando o botão Continuar ficar habilitado, clique para continuar.',
  'onboarding.mymaps.tutorial.ok': 'Ok, entendi',
  'financial_balance.period-selector.current-period': 'Período Atual',
  'map.expand': 'Aumentar',
  'map.contract': 'Diminuir',
  'iap.panel.instruction': 'Insira o Código para confirmar a entrega',
  'iap.panel.user-app': 'O Código de entrega é exibido ao cliente no aplicativo.',
  'iap.panel.skip-link': 'Não possui um Código de entrega?',
  'iap.panel.delivery-pin': 'Código da entrega',
  'iap.pin.invalid': 'Código de entrega inválido',
  'iap.skip.title': 'Você tem certeza?',
  'iap.skip.warning':
    'Você pode finalizar o pedido sem o Código da entrega, mas se houver algum problema com o pedido, você não terá evidências de que a efetuou.',
  'iap.skip.liability':
    'Você será o responsável caso o cliente afirme não ter recebido esta entrega.',
  'iap.skip.confirm': 'Finalizar pedido',
  'dealer_cancel_modal.no_pin': 'Cliente não forneceu o Código da entrega',
  'edit-shop-info-subtitle': 'Alterar informações',
  'edit-shop-info-panel-title': 'Gerenciar produtos e horário de entrega',
  // IAP pin tutorial
  'iap.pin-tutorial.title1': 'Eba! Você aceitou um pedido de pagamento no app.',
  'iap.pin-tutorial.title2': 'Valide o pagamento com o Código da entrega.',
  'iap.pin-tutorial.title3': 'Como faço para validar o pagamento?',
  'iap.pin-tutorial.step1.title': 'Consumidor recebeu o Código de entrega',
  'iap.pin-tutorial.step1.text':
    'Após efetuar o pedido pago pelo app, o consumidor recebeu o Código de entrega de 4 dígitos.',
  'iap.pin-tutorial.step2.title': 'Entregador solicita o Código de entrega',
  'iap.pin-tutorial.step2.text':
    'Solicite o Código de entrega para o consumidor no momento da entrega.',
  'iap.pin-tutorial.step3.title': 'Agora você precisa validar o pagamento',
  'iap.pin-tutorial.step3.text': 'Digite o Código para concluir a entrega.',
  'iap.pin-tutorial.faq-link': 'Porque eu preciso do Código de entrega?',
  'iap.pin-tutorial.dont-show': 'Não mostrar esta tela novamente.',
  // IAP pin tutorial
  // TnC intro
  'tnc.intro.faq': 'Ficou com dúvidas? Clique aqui para saber mais',
  'tnc.postpone.reasons': 'Motivo para adiar',
  'tnc.postpone.reasons.no_time': 'Não tenho tempo para ler agora',
  'tnc.postpone.reasons.dont_agree': 'Não concordo com alguns itens',
  'tnc.postpone.reasons.not_authorized': 'Eu não estou autorizado a aceitar',
  'tnc.postpone.reasons.dont_understand': 'Não entendi completamente',
  'tnc.postpone.reasons.other': 'Outro',
  'tnc.postpone.reasons.confirm': 'Confirmar',
  // TnC intro
  drivers: 'Entregadores',
  'drivers.page': 'Área Entregador',
  'drivers.welcome': 'Welcome',
  'drivers.creation': 'Novo entregador',
  'drivers.creation-success': 'Entregador cadastrado com sucesso!',
  'drivers.creation-success-pin-explanation':
    'PIN é o Código de acesso para o entregador poder entrar no App',
  'drivers.edition': 'Informações do Entregador',
  'driver.form.title.personal-data': 'Dados Pessoais',
  'driver.form.title.driver-license': 'CNH',
  'driver.form.title.stores': 'Lojas',
  'driver.form.subtitle.stores': 'Selecione as lojas de atuação',
  'driver.form.subtitle.stores-hint': 'Habilitar pelo menos uma loja de atuação',
  'driver.form.subtitle.hidden-stores':
    '{quantity} {quantity, plural, one {loja não está sendo exibida} other {lojas não estão sendo exibidas}}',
  'driver.form.full-name': 'Nome Completo',
  'driver.form.error.minimum-stores': 'Você deve habilitar pelo menos uma loja de atuação',
  'driver.form.username': 'Usuário',
  'driver.form.error.maximum-stores':
    'Não é possível selecionar mais de uma loja para esse modo de entrega',
  'driver.form.username-hint':
    'Sem espaços. Letras mínusculas ou maísculas e números. Exemplo: rodrigo.silva, lucas_lopes, caio12 etc.',
  'driver.form.username-static':
    'O nome de usuário é único e não pode ser alterado. Ele serve para acessar o app Chama Entregador',
  'driver.form.phone-number': 'Celular',
  'driver.form.phone-number-hint': 'Número de celular para entrar no aplicativo',
  'driver.form.e-mail': 'E-mail',
  'driver.form.driver-license-number': 'Nº de registro',
  'driver.form.driver-license-due-date': 'Validade',
  'driver.form.driver-license-category': 'Categoria',
  'driver.form.delivery-mode-title': 'Modo de entrega',
  'driver.form.delivery-mode-subtitle': 'Selecione uma forma de entrega',
  'driver.form.error.invalid-retry':
    'Este entregador ainda está sendo processado pelo nosso sistema, espere um pouco mais para tentar novamente',
  'driver.form.error.document-is-not-unique': 'Este documento já está em uso',
  'driver.form.error.phone-is-not-unique': 'Este telefone já está em uso',
  'driver.form.error.username-is-not-unique':
    'O usuário escolhido já existe, por favor escolha outro',
  'driver.form.error.invalid-date-format': 'Formato de data inválido',
  'driver.form.error.invalid-date': 'Data inválida',
  'driver.form.error.fetch': 'Não foi possível recuperar as informações solicitadas',
  'driver.form.error.expired-driver-license': 'A licença está vencida',
  'driver.form.delivery-type.pp.title': 'Portal do Parceiro',
  'driver.form.delivery-type.pp.label': 'Pedidos do cliente para a revenda',
  'driver.form.delivery-type.mobile-dealer.title': 'Revenda Móvel',
  'driver.form.error.delivery-type': 'Selecione o modo de entrega',
  'driver.form.delivery-type.mobile-dealer.label':
    'Pedidos do cliente diretamente para o entregador',
  'driver.form.driver-licence-confirmation':
    'Eu confirmo que todas as informações fornecidas são verdadeiras e correspondem ao documento CNH original.',
  'driver.form.enable-driver.description': 'Este entregador está desativado',
  'driver.form.disable-driver.description': 'Este entregador não atende mais a sua revenda?',
  'driver.form.enable-driver.action': 'ATIVAR ENTREGADOR',
  'driver.form.disable-driver.action': 'DESATIVAR ENTREGADOR',
  'driver.driver-disable-confirmation.title': 'Desativar entregador?',
  'driver.driver-disable-confirmation.text':
    'Ao desativar, o entregador não receberá mais pedidos e não poderá fazer entregas.',
  'driver.driver-disable-confirmation.disable': 'DESATIVAR ENTREGADOR',
  'driver.driver-disable-confirmation.back': 'VOLTAR',
  'driver.enabled': 'Driver ativado com sucesso!',
  'driver.disabled': 'Driver desativado com sucesso',
  'drivers.driver.create-page-title': 'Adicionar entregador',
  'drivers.driver.create-page.add': 'Adicionar',
  'drivers.driver.edit-page-title': 'Informações do entregador',
  'drivers.driver.personal-data-title': 'Dados pessoais',
  'drivers.driver.delivery-mode-title': 'Modo de entrega',
  'drivers.driver.delivery-mode-disabled':
    'Importante: apenas o agente responsável pode alterar o modo de entrega.',
  'drivers.driver.personal-data.name': 'Nome completo',
  'drivers.driver.personal-data.username': 'Usuário',
  'drivers.driver.personal-data.username.description': 'Acesso no app Chama Entregador',
  'drivers.driver.personal-data.required-fields': 'Campos obrigatórios',
  'drivers.driver.delivery-type.pp.title': 'Portal do Parceiro',
  'drivers.driver.delivery-type.pp.description': 'Pedidos de clientes para a revenda',
  'drivers.driver.delivery-type.mobile-dealer.title': 'Revenda Móvel',
  'drivers.driver.delivery-type.mobile-dealer.description':
    'Pedidos de clientes diretamente para o app entregador',
  'drivers.driver.user-info.status.enabled': 'Entregador ativo',
  'drivers.driver.user-info.status.disabled': 'Entregador desativado',
  'drivers.driver.user-info.generate-password': 'Gerar senha temporária',
  'terms-and-conditions-confirmation': 'Eu confirmo a leitura dos {termsLink} e da {privacyLink}',
  'terms-and-conditions-confirmation.terms': 'Termos e Condições',
  'terms-and-conditions-confirmation.privacy': 'Política de Privacidade',
  'drivers.driver-card.delivery-mode.mobile-dealer': 'Revenda Móvel',
  'drivers.driver-card.delivery-mode.territory-trackedr': 'Entregador',
  'drivers.create-driver': 'Adicionar novo entregador',
  'drivers.page-title': 'Entregadores',
  'drivers.enabled-drivers-title': 'Entregadores ativos',
  'drivers.disabled-drivers-title': 'Entregadores desativados',
  'drivers.no-drivers.call-to-action-description': 'Adicione seu primeiro entregador',
  'drivers.no-drivers.call-to-action': 'Adicionar entregador',
  'drivers.no-drivers.tutorial.driver-app-value-part-1': 'Com o app',
  'drivers.no-drivers.tutorial.driver-app-value-part-2': 'Chama Entregador',
  'drivers.no-drivers.tutorial.driver-app-value-part-3':
    'você faz entregas mais rápidas e acompanha tudo em tempo real.',
  'drivers.no-drivers.tutorial.steps-title': 'Veja como funciona:',
  'drivers.no-drivers.tutorial.step-1': 'Adicione seu primeiro entregador',
  'drivers.no-drivers.tutorial.step-2.part-1': 'Baixe o app',
  'drivers.no-drivers.tutorial.step-2.part-2': 'Chama Entregador',
  'drivers.no-drivers.tutorial.step-2.part-3': 'no celular do entregador',
  'drivers.no-drivers.tutorial.step-3':
    'Envie pedidos para o entregador através da página de Pedidos',
  create: 'Cadastrar',
  save: 'Salvar',
  cancel: 'Cancelar',
  'no-options': 'Não há opções',
  'tap-to-select': 'Selecionar',
  'required-fields': 'Campos obrigatórios',
  'new-driver': 'Novo Entregador',
  'chama-driver': 'Chama Entregador',
  pin: 'PIN',
  username: 'Usuário',
  'bank-account.dealer.name': 'Empresa:',
  'bank-account.dealer.cnpj': 'CNPJ:',
  'bank-account.dealer.contact-name': 'Contato:',
  'bank-account.dealer.save': 'Salvar',
  'bank-account.fetch.error': 'Contate o Chama para poder acessar essa página',
  'bank-account.save.error': 'Não foi possível salvar seus dados, contate o Chama',
  'bank-account.success':
    'Seus dados foram salvos com sucesso! Se você deseja mudá-los novamente, por favor contacte o Chama',
  'bank-account.finish': 'Finalizar',
  'bank-account.form.header': 'Por favor, informe os dados bancários da revenda:',
  'bank-account.form.bank': 'Banco',
  'bank-account.form.branch': 'Número da agência',
  'bank-account.form.branch-digit': 'Digito da agência',
  'bank-account.form.account-number': 'Número da conta',
  'bank-account.form.account-digit': 'Digito da conta',
  'bank-account.form.dealer.anotherAccountHolder':
    'Marque essa caixa se você está transferindo para um titular diferente',
  'bank-account.form.company-name': 'Nome da empresa',
  'bank-account.form.cnpj': 'CNPJ',
  'bank-acount.fetch.general-error': 'Contate o Chama para poder acessar essa página',
  'one-star-modal.title': 'Você tem certeza que deseja cancelar?',
  'one-star-modal.fact': 'O cliente já esperou por mais de uma hora!',
  'one-star-modal.consequence':
    'Caso você cancele agora a sua avaliação será de 1 estrela neste pedido.',
  'one-star-modal.keep': 'Manter o pedido',
  'one-star-modal.cancel': 'Cancelar o pedido',
  'one-star-modal.chat': 'Falar com o suporte chama',
  'driver.password-generation.confirmation.title': 'Você gostaria de gerar uma senha temporária?',
  'driver.password-generation.confirmation.text':
    'Se você gerar uma senha temporária, automaticamente a senha anterior deixará de funcionar.',
  'driver.password-generation.confirmation.user': 'Usuário',
  'driver.password-generation.confirmation.new-password': 'Gerar nova senha',
  'driver.password-generation.confirmation.back': 'Voltar',
  'driver.password-generation.loading.title':
    'Estamos gerando uma senha temporária para o entregador',
  'driver.password-generation.loading.password': 'Senha temporária',
  'driver.password-generation.loading.user': 'Usuário',
  'driver.password-generation.success.title': 'Nova senha temporária gerada com sucesso!',
  'driver.password-generation.success.text':
    'Atenção: Informe a nova senha para que o entregador consiga entrar no app',
  'driver.password-generation.success.user': 'User',
  'driver.password-generation.success.password': 'Senha temporária',
  'driver.password-generation.success.new-password': 'Copiar senha',
  'driver.password-generation.success.back': 'Fechar',
  'driver.form.generate-password': 'Gerar senha temporária',
  'driver.password-generation.success.copy-password': 'Copiar senha',
  'driver.password-generation.success.close': 'Fechar',
  'driver.password-generation.success.copy-message': `Use a senha temporária para acessar o app Chama Entregador.
Usuário: {userName}
Senha: {password}
`,
  'driver.password-generation.success.copied-text': 'Texto copiado',
  'customer-phones.issue-with-order': 'Olá! Existe um problema com o pedido: {orderId}',
  'customer-phones.view-number': 'Ver número',
  'customer-phones.masked-number-tooltip':
    'Para proteger a privacidade do cliente, esse é um número de telefone temporário que permite a comunicação até a entrega do pedido.',
  'customer-phones.contact-support': 'Problema na entrega?',
  'customer-phones.contact-support-tooltip':
    'Em caso de problemas com o pedido, entre em contato com o Suporte Chama e nós ajudaremos a resolver.',
  'tracking.menu.title': 'Monitoramento',
  'tracking.title': 'Entregador',
  'tracking.show-driver-radius.label': 'Raio de cobertura',
  'tracking.content.title': 'Monitoramento',
  'notifications.missing-opening-hours':
    'A loja {shopName} está fechada devido à atualização da horário de entrega. Por favor, configure seus horário de entrega para reabrir a loja.',
  'notifications.missing-opening-hours.link-text': 'Atualizar horário de entrega',
  'notifications.missing-products':
    'A loja {shopName} está fechada devido à atualização da marca. Por favor, configure seus produtos para reabrir a loja.',
  'notifications.missing-products.link-text': 'Atualizar produtos',
  'notifications.missing-products-popup.title': 'Atualize seus produtos',
  'notifications.missing-products-popup.text':
    'Conforme solicitado, nós atualizamos a marca da sua loja e redefinimos sua lista de produtos. Por favor, configure seus produtos com preço e marca para que sua loja volte a ficar aberta e receber novos pedidos.',
  'notifications.missing-products-popup.button-text': 'Atualizar produtos',
  'driverdetail.status.online.title': 'ONLINE',
  'driverdetail.status.online.description': 'em tempo real',
  'driverdetail.status.offline.title': 'OFFLINE',
  'driverdetail.status.offline.description': 'última posição',
  'ordersinfo.noorders.text': 'Nenhuma entrega no dia de hoje',
  'ordersinfo.ongoing-orders.title': 'Em andamento',
  'ordersinfo.finished-orders.title': 'Concluídos',
  'ordersinfo.orders-count':
    '{count, number} {count, plural, one {pedido} =0 {pedidos} other {pedidos}}',
  'orders.all': 'Todos os pedidos',
  'orders.history': 'Histórico',
  'orders.late_orders': 'Pedidos atrasados',
  'orders.range': '{filtered} de {total} pedidos',
  'orders.waiting.interaction': 'Aguardando interação',
  gas: 'Gás',
  'dealer-products.form.errors.price-out-of-range': 'Este preço está muito fora do padrão',

  'news.menu-entry': 'Novidades',

  'serviceareas.title': 'Produtos e cobertura',
  'serviceareas.title.map': 'Mapa de entrega',
  'serviceareas.title.map-hint':
    'Os consumidores dentro dessa área de cobertura vão pagar o preço definido na seção "Produtos".',
  'serviceareas.title.opening-times': 'Horários de funcionamento',
  'serviceareas.title.opening-times-hint':
    'Altere o horário de funcionamento da revenda nesta área.',
  'serviceareas.title.products': 'Produtos',
  'serviceareas.title.products-hint':
    'Aqui você pode alterar o preço do seu produto na área selecionada. Se quiser alterar o preço de outra área escolha ela acima.',
  'serviceareas.title.select-area': 'Área de cobertura',
  'serviceareas.title.select-area-hint':
    'Cada área pode ter características diferentes. Escolha uma área para editar marca, preço, mapa de entrega e horário de funcionamento.',
  'serviceareas.title.area-name': 'Nome da área',
  'serviceareas.title.area-name-hint': 'Coloque o melhor nome para controle interno da revenda.',
  'serviceareas.map.notfound': 'Esta loja não possui um mapa de entrega.',
  'serviceareas.mapview.title': 'Editar mapa de entrega',
  'serviceareas.name.label': 'Nome da área (apenas visível para a revenda)',
  'serviceareas.name.success': 'Nome da área editado com sucesso',
  'serviceareas.name.errors.generic': 'Erro ao editar o nome da area',
  'serviceareas.name.errors.area-name-exists': 'Este nome já é usado em outra área',
  'serviceareas.creation.title': 'Adicionar nova área de cobertura',
  'serviceareas.creation.create': 'Salvar nova área',
  'serviceareas.creation.step-1.title': 'Defina a área de cobertura',
  'serviceareas.creation.step-1.description': 'Para definir a área de cobertura, utilize o',
  'serviceareas.creation.step-2.title': 'Cole o link do mapa criado',
  'serviceareas.creation.step-2.description':
    'Quando seu mapa estiver pronto, cole o link no campo abaixo:',
  'serviceareas.creation.step-3.title': 'Crie um nome para esta área',
  'serviceareas.creation.step-3.description':
    'Para diferenciar as áreas, nós sugerimos usar nomes do bairro ou nome da região.',
  'serviceareas.creation.map-link.label': 'Importar mapa do Google MyMaps',
  'serviceareas.creation.map-link.placeholder': 'Cole o link do Google MyMaps aqui',
  'serviceareas.creation.area-name.label.part-1': 'Nome da área',
  'serviceareas.creation.area-name.label.part-2': 'Apenas visível pela revenda',
  'serviceareas.creation.area-name.placeholder': 'Insira um nome para esta área',
  'serviceareas.creation.success': 'Área {areaName} criada com sucesso!',
  'serviceareas.creation.errors.generic': 'Erro ao criar área de cobertura.',
  'serviceareas.errors.name-too-short':
    'O nome deve ter no mínimo {minimum} caracteres. Por favor, altere para salvar.',
  'serviceareas.errors.name-too-long':
    'O nome deve ter no máximo {maximum} caracteres. Por favor, altere para salvar.',
  'serviceareas.errors.name-with-sequence-of-whitespaces':
    'O nome não pode ter 2 espaços entre as palavras. Por favor, altere para salvar.',
  'serviceareas.errors.name-with-sequence-of-special-characters':
    'O nome não pode ter 2 caracteres especiais juntos. Exemplo: / ou -. Por favor, altere para salvar.”',
  'serviceareas.errors.name-with-invalid-position-for-special-characters':
    'Não pode ter caracteres especiais ou espaço no começo ou final do nome. Por favor, altere para salvar.',
  'serviceareas.errors.wrong-map-link': 'Link inválido. Verifique e tente novamente',
  'serviceareas.errors.invalid-map-shape': 'Formato do mapa inválido.',
  'serviceareas.errors.area-name-exists': 'Este nome já é usado em outra área',
  'serviceareas.errors.failed-to-fetch-an-area': 'Erro ao carregar áreas de cobertura',
  'serviceareas.area-name': 'Nome da área',
  'serviceareas.empty.text':
    'Para a loja começar a vender o Chama precisa adicionar uma área de cobertura!',
  'serviceareas.empty.button.chamaagent': 'Adicionar área de cobertura',
  'serviceareas.empty.button.user': 'Falar com o Chama',

  'dealers.search': 'Pesquisar revendas',

  save_edition: 'Salvar edição',
  'tracking-page.driver.price.insert-message':
    'Insira o preço personalizado para sua Revenda Móvel',
  'tracking-page.driver.price.insert': 'Inserir preço',
  'tracking-page.driver.price.edit': 'Editar preço',
  'tracking-page.driver.price.brand': 'Marca',
  'tracking-page.driver.price.select-brand': 'Marca',
  'tracking-page.driver.price.current-price': 'Preço',
  'tracking-page.driver.price.cancel': 'Cancelar',
  'tracking-page.driver.price.save': 'Salvar',
  'tracking-page.driver.date-format': 'dddd, D [de] MMMM',
  'bottlesmetric.title': 'Botijões',
  'deliverymetric.title': 'Entregas',
  'coverageareamap.notifications.map-saved': 'Área de cobertura salva',
  'coverageareamap.notifications.map-save-failed': 'Erro ao salvar as alterações. Tente novamente',
  'order.address': 'Endereço',
  'order.complement': 'Complemento',
  'order.reference-point': 'Ponto de referência',
  'order.remark': 'Dicas para o entregador',
  'order.cpf-title': 'Cliente pediu CPF na nota',
  'order.cnpj-title': 'Cliente pediu CNPJ na nota',
  'order.cpf-label': 'CPF',
  'order.cnpj-label': 'CNPJ',
  'employees.roles.chamaagent': 'Operador Chama',
  'employees.roles.operator': 'Operador',
  'employees.roles.admin': 'Administrador',
  'employees_overview.menu': 'Usuários',
  'employees_overview.no-employees': 'Você ainda não tem usuários cadastrados',
  'employees_overview.page_title': 'Gerenciamento de usuários',
  'employees_overview.users_registered': 'Usuários ativos',
  'employees_overview.users_pending': 'Usuários pendentes',
  'employees_overview.users_disabled': 'Usuários desativados',
  'orders.delivery-mode.mobile.dealer': 'Revenda móvel',
  'orders.delivery-mode.unnamed-area': 'Área sem nome',
  'performance_page.menu': 'Desempenho',
  'performance_page.page_title': 'Desempenho',
  'employees_overview.edit.page_title': 'Informações do usuário',
  'employees_overview.edit.personal_data': 'Dados pessoais',
  'employees_overview.edit.access_permissions': 'Permissões de acesso',
  'employees_overview.edit.user_online': 'Usuário online',
  'employees_overview.edit.user_enabled': 'Usuário ativo',
  'employees_overview.edit.user_disabled': 'Usuário inativo',
  'employees_overview.edit.mandatory_fields': 'Campos obrigatórios',
  'employees_overview.edit.full_name': 'Nome completo',
  'employees_overview.edit.email': 'E-mail',
  'employees_overview.edit.email_helper': 'Login no Portal do Paceiro',
  'employees_overview.edit.phone': 'Celular',
  'employees.overview.edit.role_updated': 'Permissão de acesso alterada com sucesso!',
  'employees_overview.edit.role.admin': 'Administrador',
  'employees_overview.edit.role.admin_explanation':
    'Acesso completo no Portal do Parceiro, inclusive painel financeiro',
  'employees_overview.edit.role.operator': 'Operador',
  'employees_overview.edit.role.operator_explanation': 'Controle de entregas e ajustes de preço',

  'employees_overview.edit.disable-confirmation.title': 'Desativar usuário?',
  'employees_overview.edit.disable-confirmation.text':
    'Desativar o usuário é algo permanente e ele não terá mais acesso à loja { shopName } no Portal do Parceiro Chama.',
  'employees_overview.edit.disable-confirmation.disable': 'Desativar usuário',
  'employees_overview.edit.disable-confirmation.back': 'Voltar',

  'employees_overview.edit.employee_enabled': 'Usuário ativado com sucesso!',
  'employees_overview.edit.employee_disabled': 'Usuário desativado com sucesso!',

  'employees_overview.edit.status.enable': 'Ativar usuário',
  'employees_overview.edit.status.disable': 'Desativar usuário',
  'employees_overview.edit.status.enabled_info': 'Este usuário está desativado',
  'employees_overview.edit.status.disable_info': 'Este usuário não atende mais a sua revenda?',
  'permissions.page_permission_denied':
    'Infelizmente você não possui acesso a esta página, consulte o administrador da revenda.',

  'form.field.email': 'Email',
  'form.field.email.placeholder': 'Insira o e-mail do operador',
  'form.field.email.helper': 'Login no Partner Portal',

  'employees.invite.title': 'Adicionar usuário',
  'employees.invite.message': 'Insira o e-mail do seu operador para garantir acesso à loja {shop}:',
  'employees.invite.email-placeholder': 'Insira o e-mail do operador',

  'employees.invite.user-added': 'Usuário adicionado com sucesso!',
  'employees.invite.user-created.description':
    'Para o primeiro login, informe a senha temporária para o seu operador:',
  'employees.invite.user-invited.description':
    'Agora o operador poderá acessar a loja {shop} no Portal do Parceiro.',
  'employees.invite.email-to-login': 'E-mail para login:',
  'employees.invite.temporary-password': 'Senha temporária:',

  'first_login_page.form.email_for_login': 'E-mail para login',
  'first_login_page.form.header.personal_data': 'Dados pessoais',
  'first_login_page.form.input.full_name': 'Nome completo',
  'first_login_page.form.input.phone': 'Celular',
  'first_login_page.form.header.password': 'Senha de acesso',
  'first_login_page.form.input.new_password': 'Inserir nova senha',
  'first_login_page.form.input.new_password.placeholder': 'Insira uma senha',
  'first_login_page.form.input.repeat_password': 'Confirmar nova senha',
  'first_login_page.form.input.repeat_password.placeholder': 'Repetir a sua senha',
  'first_login_page.form.input.confirm_tnc':
    'Eu confirmo a leitura dos {termsLink} e {privacyLink}',
  'first_login_page.form.required_fields': 'Campos obrigatórios',
  'first_login_page.form.submit_button': 'Salvar informações',
  'first_login_page.form.errors.name.short': 'Nome muito curto',
  'first_login_page.form.errors.name.long': 'Nome muito longo',
  'first_login_page.form.links.terms': 'Termos e Condições',
  'first_login_page.form.links.privacy': 'Política de Privacidade',
  'first_login_page.heading.big': 'Seja bem-vindo(a) ao Portal do Parceiro Chama!',
  'first_login_page.heading.small':
    'Para continuar precisamos que você complete seu cadastro no formulário abaixo:',
  'first_login_page.form.errors.name.no_last_name': 'Pelo menos o nome e sobrenome são requeridos',
  'first_login_page.form.errors.phone.short': 'Telefone inválido',
  'first_login_page.form.errors.phone.long': 'Telefone inválido',
  'employee.pending-creation': 'Usuário ainda não fez o primeiro login',
  'first_login_page.form.errors.phone.only_numbers': 'Somente números são permitidos',
  'first_login_page.form.errors.password.short': 'Mínimo de 8 caracteres',
  'first_login_page.form.errors.password.must_match': 'As senhas devem corresponder',
  'first_login_page.form.errors.tnc.must_check': 'Você deve aceitar os termos e condições',

  'store_detail_view.store_info': 'Informações da loja',
  'store_detail_view.app_visible_data': 'Dados visíveis no App',
  'store_detail_view.app_name': 'Nome no aplicativo',
  'store_detail_view.main_phone': 'Telefone de atendimento',
  'store_detail_view.internal_data': 'Dados internos',
  'store_detail_view.cnpj.tip': 'Razão Social da Revenda',
  'store_detail_view.store_email': 'E-mail do revendedor',
  'store_detail_view.support_phones': 'Telefones de contato / WhatsApp',
  'store_detail_view.button.edit': 'Editar informações',
  'store_detail_view.support_text': 'Caso precise mudar alguma dessas informações',
  'store_detail_view.support_text_link': 'entre em contato com o Chama',

  'form.validations.min-size': 'Utilize no mínimo {number} caracteres',
  'form.validations.max-size': 'Utilize no máximo {number} caracteres',
  'form.validations.invalid-email': 'Email inválido',
  'form.validations.invalid-phone': 'Telefone inválido',
  'form.validations.required': 'Campo obrigatório',
  'form.validations.only-numbers': 'Somente números são permitidos',

  'tracking.driver-list.card.unavailable': 'Indisponivel',
  'tracking.driver-list.card.available': 'Disponivel',
  'tracking.driver-list.card.delivering':
    'Em { deliveries, number } { deliveries, plural, one { entrega } other { entregas }}',
  'tracking.driver-list.card.mobile-dealer': 'Revenda móvel',
  'tracking.driver-list.card.territory-order': 'Entregador',
  'tracking.driver-list.group.online': 'Online',
  'tracking.driver-list.group.offline': 'Offline',
  'tracking.driver-list.group.drivers':
    '{ drivers } {drivers,plural, one { entregador } other { entregadores }}',
  'tracking.driver-list.group.driverless-title':
    'Quer ter mais controle e velocidade nas suas entregas?',
  'tracking.driver-list.group.driverless-text':
    'Adicione seus entregadores, controle sua frota e entregue mais rápido.',
  'tracking.driver-list.group.driverless-cta': 'Adicionar entregador',
  'opening_time_status.close_confirmation_modal.selector.placeholder': 'Selecione um motivo',
  'opening_time_status.close_confirmation_modal.selector.empty': 'Sem motivos disponíveis',
  'opening_time_status.close_confirmation_modal.reason.stock': 'Não tenho estoque no depósito',
  'opening_time_status.close_confirmation_modal.reason.only-at-door-or-phone':
    'Estou atendendo apenas telefone e/ou portaria',
  'opening_time_status.close_confirmation_modal.reason.high-demand':
    'Estou com alta demanda, não consigo atender neste momento',
  'opening_time_status.close_confirmation_modal.reason.problems-with-pp':
    'Problemas com o Portal do Parceiro',
  'opening_time_status.close_confirmation_modal.reason.finished-work-shift':
    'Encerrei a jornada de trabalho hoje',
  'opening_time_status.close_confirmation_modal.reason.no-drivers': 'Estamos sem entregadores',
  'opening_time_status.close_confirmation_modal.reason.other': 'Outra razão',
  'coverageareamap.form.tips.1': 'Crie/edite o mapa usando o',
  'coverageareamap.form.tips.2': 'Coloque um marcador na localização exata da loja',
  'coverageareamap.form.tips.3': 'Desenhe uma ou mais áreas de entrega',
  'coverageareamap.form.tips.3.1':
    'Uma área de entrega não pode ter buracos ou fazer interseções com si mesma;',
  'coverageareamap.form.tips.3.2': 'Duas áreas de entrega podem se sobrepor;',
  'coverageareamap.form.tips.4':
    'Compartilhe o mapa no modo "Qualquer um com o link pode visualizar"',
  'coverageareamap.form.tips.5': 'Cole o link no campo acima',
  'coverageareamap.form.tips.6':
    'Espere aproximadamente 2 minutos para enviar as alterações (tempo de processamento do mapa)',
  'coverageareamap.form.link_input.label': 'Importar mapa do Google MyMaps',
  'coverageareamap.form.errors.dealerareafetcherror':
    'Não é possível buscar no google meus mapas, o mapa tem as permissões corretas?',
  'coverageareamap.form.errors.dealerareazerolocations':
    'Nenhum local do revendedor fornecido, precisa exatamente de um',
  'coverageareamap.form.errors.dealerareamultiplelocations':
    'Vários locais de revendedores, precisam de exatamente um',
  'coverageareamap.form.errors.dealerareazeropolygons':
    'Nenhuma área de revendedor fornecida, precisa de um ou mais',
  'coverageareamap.form.errors.dealerareapolygonserrors':
    'As áreas do revendedor têm orifícios ou auto-interseções',

  'telephoneorder.order-draft-card.continue': 'Continuar preenchimento',
  'telephoneorder.form.toast-success': 'Pedido adicionado com sucesso!',
  'telephoneorder.form.toast-error': 'Ops! Algo deu errado!',
  'telephoneorder.form.title': 'Adicionar pedido por telefone',
  'telephoneorder.form.button.addorder': 'Confirmar pedido',
  'telephoneorder.form.button.continue-later': 'Continuar depois',
  'telephoneorder.form.field.consumerName': 'Nome do cliente',
  'telephoneorder.form.field.consumerName.placeholder': 'Ex. Ana Maria ',
  'telephoneorder.form.field.telephone': 'Telefone',
  'telephoneorder.form.field.telephone.placeholder': '(XX) XXXXX-XXXX',
  'telephoneorder.form.field.streetName': 'Endereço',
  'telephoneorder.form.field.streetName.placeholder': 'Ex. Rua, avenida...',
  'telephoneorder.form.field.number': 'Número',
  'telephoneorder.form.field.number.placeholder': 'Ex. 1234',
  'telephoneorder.form.field.complement': 'Apto, bloco, casa...',
  'telephoneorder.form.field.complement.placeholder': 'Ex. Casa dos fundos, bloco 1...',
  'telephoneorder.form.field.reference': 'Ponto de referência',
  'telephoneorder.form.field.reference.placeholder': 'Ex. Próximo à padaria',
  'telephoneorder.form.field.product': 'Produto',
  'telephoneorder.form.field.brand': 'Marca',
  'telephoneorder.form.field.brand.loading': 'Carregando marcas...',
  'telephoneorder.form.field.quantity': 'Qtde.',
  'telephoneorder.form.field.paymenttype': 'Pagamento',
  'telephoneorder.form.field.price': 'Preço unitário',
  'telephoneorder.form.field.price.placeholder': 'R$ XX,XX',
  'telephoneorder.form.field.comment': 'Comentários',
  'telephoneorder.form.field.comment.placeholder':
    'Ex. Troco, dicas, mensagem para o entregador...',
  'autocomplete.fetching-data': 'Carregando resultados...',
  'autocomplete.not-found': 'Ops! Nenhum resultado encontrado.',
  'telephoneorder.form.errors.consumerName.missing': 'Insira um nome',
  'telephoneorder.form.errors.consumerName.short': 'Insira um nome válido',
  'telephoneorder.form.errors.telephone.missing': 'Insira um telefone',
  'telephoneorder.form.errors.telephone.invalid': 'Telefone inválido',
  'telephoneorder.form.errors.streetName.missing': 'Insira um endereço',
  'telephoneorder.form.errors.price.missing': 'Insira um preço válido',
  'telephoneorder.update-form.toast-failure':
    'Não foi possível salvar as alterações. Tente novamente',

  'orderhistory.header.title': 'Histórico de pedidos',
  'orderhistory.emptyorders':
    'Ops... Nenhum pedido encontrado para a pesquisa ou período selecionado',
  'orderhistory.genericerror':
    'Desculpe! Não foi possível carregar os últimos pedidos. Tente novamente mais tarde.',
  'orderhistory.table.summary.simple':
    '{count, plural, one {# pedido encontrado} other {# pedidos encontrados}}',
  'orderhistory.table.summary.opensearch':
    '{count, plural, one {# pedido encontrado} other {# pedidos encontrados}} com o termo "{searchTerm}"',
  'orderhistory.table.header.consumer': 'Consumidor',
  'orderhistory.table.header.address': 'Endereço',
  'orderhistory.table.header.products': 'Produto(s)',
  'orderhistory.table.header.paymentType': 'Pagto.',
  'orderhistory.table.header.value': 'Valor',
  'orderhistory.table.header.salesChannel': 'Venda',
  'orderhistory.table.header.driver': 'Entregador',
  'orderhistory.table.header.time': 'Tempo',
  'orderhistory.table.header.orderPlacedAt': 'Entrada',
  'orderhistory.table.header.finalizedAt': 'Finalizado',
  'orderhistory.table.header.status': 'Status',
  'orderhistory.pagination.next.tooltip': 'Próximo',
  'orderhistory.pagination.prev.tooltip': 'Anterior',
  'orderhistory.pagination.text.first_line': '{start} a {end}',
  'orderhistory.pagination.text.second_line': 'de {total} pedidos',
  'general.logout.error': 'Erro ao sair, por favor, tente novamente',
  'orderhistory.filters.openfield': 'Endereço ou consumidor',
  'orderhistory.filters.calendar.start-date-placeholder': 'Data inicial',
  'orderhistory.filters.calendar.end-date-placeholder': 'Data final',

  'shopselector.label': 'Loja selecionada',

  'feature-advertiser-popup.checkbox': 'Não mostrar essa mensagem novamente',

  'driver-app-advertiser-popup.title': 'Chegou o app Chama Entregador',
  'driver-app-advertiser-popup.text':
    'Com ele você faz entregas mais rápidas e acompanha tudo em tempo real. Para começar, cadastre seus entregadores.',
  'driver-app-advertiser-popup.action.close': 'Fechar',
  'driver-app-advertiser-popup.action.register': 'Adicionar entregador',

  'service-areas-advertiser-popup.title': 'Mais praticidade com as Áreas de cobertura!',
  'service-areas-advertiser-popup.text':
    'Com elas você simplifica o dia a dia da sua revenda e ganha clareza na visualização das suas lojas.',
  'service-areas-advertiser-popup.action.close': 'Fechar',
  'service-areas-advertiser-popup.action.action': 'Saiba mais',

  'restriction-areas.success-message.area-imported': 'Área de restrição salva com sucesso',
  'restriction-areas.error-message.unknown': 'Erro ao salvar área de restrição',
  'restriction-areas.error-message.url-not-valid':
    'Não foi possível identificar o mapa com o link acima',
  'restriction-areas.error-message.map-shape-not-valid': 'Polígono inválido para área de restrição',
  'restriction-areas.error-message.restriction-area-not-found': 'Erro ao salvar área de restrição',
  'restriction-areas.error-message.not-allowed': 'Erro ao salvar área de restrição',

  'alternative-give-up-header.title.cancel': 'Qual o motivo do cancelamento?',
  'alternative-give-up-header.explanation.cancel':
    'Se você cancelar o pedido, o Chama poderá encaminhá-lo para outro revendedor na região.',
  'alternative-give-up-header.title.decline': 'Qual o motivo de recusar o pedido?',
  'alternative-give-up-header.explanation.decline':
    'Se você recusar o pedido, o Chama poderá encaminhá-lo para outro revendedor na região.',
  'add-telephone-order-button.label': 'Adicionar pedido',
  'add-telephone-order.panel.tooltip.text':
    'Não se preocupe, as informações do pedido são exclusivas de sua revenda.',
  'add-telephone-order.panel.tooltip.link-text': 'Clique aqui para saber mais',
};
/* eslint-disable max-len */

export default messages;



// WEBPACK FOOTER //
// ../utils/i18n/messages/pt-BR.js